import dynamic from 'next/dynamic'
import { analytics } from '@helpers/analytics'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import styles from './styles.module.scss'

const ProductOptionModal = dynamic(
  () => import('@components/product/ProductOptionModal')
)
const Modal = dynamic(() => import('@components/ui/Modal'))

const BUILD_DATA = [
  {
    text: 'Narrow',
    subTitle: 'A - Narrow thighs',
    description:
      'For men with a straight and narrow shape, with little shape through the seat, hips and thigh.',
    img: {
      url: 'https://cdn.shopify.com/s/files/1/0207/9406/files/A.jpg?v=1680006691',
      width: 315,
      height: 463
    }
  },
  {
    text: 'Regular',
    subTitle: 'B - Regular thighs',
    description:
      'For men with a bit of shape. If you find that most chinos off the shelf fit well, then this will likely be the build for you.',
    img: {
      url: 'https://cdn.shopify.com/s/files/1/0207/9406/files/B.jpg?v=1680006691',
      width: 315,
      height: 463
    }
  },
  {
    text: 'Wide',
    subTitle: 'C - Wide thighs',
    description:
      'For men who often have to go up a waist size to accommodate your thighs/seat - this is the build for you.',
    img: {
      url: 'https://cdn.shopify.com/s/files/1/0207/9406/files/C.jpg?v=1680006691',
      width: 315,
      height: 463
    }
  }
] as const

type BuildSubtitleWithModalProps = {
  modalOpen: boolean
  toggleModal: () => void
}

function BuildSubtitleWithModal({
  modalOpen,
  toggleModal
}: BuildSubtitleWithModalProps) {
  const handleOpenModal = () => {
    toggleModal()
    analytics('Click', {
      label: 'What’s my build?'
    })
  }
  const modalProps = {
    data: BUILD_DATA,
    byline: '',
    title: 'Compare builds'
  }

  return (
    <>
      <div className={styles.subtitle__container}>
        <h2 className={styles.subtitle}>Build</h2>
        <div className={styles.subtitle}>
          <ButtonMinimal underlined onClick={handleOpenModal}>
            What's my build?
          </ButtonMinimal>
        </div>
      </div>
      {modalOpen && (
        <Modal onClose={toggleModal} openedModal={modalOpen}>
          <ProductOptionModal {...modalProps} />
        </Modal>
      )}
    </>
  )
}

export default BuildSubtitleWithModal
